import { get } from 'es-toolkit/compat';
import * as React from 'react';
import { FieldProps } from 'formik';

import { Select } from './Select';

interface Props extends FieldProps {
  className?: string;
  label?: string;
  onChange?(event: React.ChangeEvent<HTMLSelectElement>): void;
  onBlur?(event: React.FocusEvent<HTMLSelectElement>): void;
  options: SelectOption[];
}

/**
 * @deprecated
 * Plase see ui folder of your project
 * Use `FormikSelect` to have a <select /> with options
 *
 * ```js
 * import { FormikSelect } from '.';
 * ```
 */
export class FormikSelect extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { field, onChange } = this.props;

    field.onChange(event);

    if (onChange) {
      onChange(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLSelectElement>) => {
    const { field, onBlur } = this.props;

    field.onBlur(event);

    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      className,
      field,
      form: { touched, errors },
      label,
      onBlur,
      onChange,
      ...props
    } = this.props;

    const hasError = !!(get(touched, field.name) && get(errors, field.name));

    return (
      <Select
        label={label}
        className={className}
        hasError={hasError}
        error={get(errors, field.name)}
        {...field}
        {...props}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
